import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router';
import { useFullBook, useUser } from '../../shared/hooks';
import { TrajectoryView } from '../components';
import { Loading } from '../../shared/components';
import { StudentFiltersEnum, TeacherFiltersEnum } from '../../shared/constants';
import { UrlParams } from '../../shared/types';
import { useAppDispatch, useAppSelector } from '../../shared/hooks/useAppDispatch';
import { checkTrajectoryHasLock } from '../../shared/slices/trajectories/api/trajectoryApiSlice';
import {
  setCurrentTrajectoryId,
  setCurrentBookId,
  setCurrentChapterId,
} from '../../shared/slices/trajectories/entity/trajectorySlice';
import {
  setEnabledFilters,
  setFilterMode,
  setShowFilters,
} from 'src/modules/shared/slices/filters/entity/FiltersSlice';
import { setBook } from 'src/modules/shared/slices/privatePageSettings/entity/privatePageSettingsSlice';

const TrajectoryViewPage: FC = () => {
  // hooks
  const { bookId, chapterId, trajectoryId } = useParams<UrlParams>();
  const fullBook = useFullBook();
  const dispatch = useAppDispatch();
  const { isStudent } = useUser();

  // redux
  const book = useAppSelector((state) => state.privatePageSettings.book);
  const user = useAppSelector((state) => state.auth.user);

  useEffect(() => {
    if (bookId && chapterId && trajectoryId && user) {
      if (!isStudent) {
        dispatch(checkTrajectoryHasLock(trajectoryId));
      }
      dispatch(setCurrentTrajectoryId(trajectoryId));
      dispatch(setCurrentBookId(bookId));
      dispatch(setCurrentChapterId(chapterId));
    }
  }, [dispatch, trajectoryId, bookId, chapterId, user, isStudent]);

  useEffect(() => {
    dispatch(setFilterMode('trajectory'));
    dispatch(
      setEnabledFilters([TeacherFiltersEnum.FOLLOW_UP, StudentFiltersEnum.PROGRESS_AND_SCORES])
    );
    dispatch(setShowFilters(true));
  }, [user?.roles, dispatch]);

  // TODO - fullbook will eventually be migrated to redux
  useEffect(() => {
    if (fullBook.success && fullBook.data) {
      dispatch(setBook(fullBook.data));
    }
  }, [fullBook, dispatch]);

  if (!bookId || !chapterId || !trajectoryId) return <div>Not a valid trajectoryId.</div>;

  return !!book ? <TrajectoryView /> : <Loading />;
};

export default TrajectoryViewPage;
